import React from 'react';

import moment from 'moment';

import icDoc from 'assets/image/ic_doc.png';
import icPdf from 'assets/image/ic_pdf.png';
import icVideo from 'assets/image/ic_video.png';

export default function CustomeChatBubble({ chat, currentUserId, isLastInGroup }) {

    const isMine = chat.userid === currentUserId;

    const getFileIcon = () => {
        if (!chat.filename) return icVideo;
        const ext = chat.filename.split('.').pop().toLowerCase();
        if (["pdf"].includes(ext)) return icPdf;
        if (["mp4", "mov"].includes(ext)) return icVideo;
        return icDoc;
    };

    const isImage = () => {
        if (!chat.filename) return false;
        const ext = chat.filename.split('.').pop().toLowerCase();
        return ['jpg', 'jpeg', 'png'].includes(ext);
    };

    return (
        <div className={`flex w-full mb-3 ${isMine ? "justify-end" : "justify-start"}`}>
            <div className={`max-w-[60%] p-2 rounded-xl shadow relative ${isMine ? "bg-gray-300 text-black" : "bg-white text-black"}`}>
                {!isMine && <p className="text-xs font-semibold mb-1">{chat.name}</p>}

                {chat.type === "uploading" && (
                    <div className="flex flex-col items-center">
                        {
                            isImage() ? <img src={URL.createObjectURL(new Blob([chat.file]))} alt="preview" className="max-w-[150px] rounded mb-2" /> : <div className="flex items-center gap-2">
                                <img src={getFileIcon()} alt="file" className="w-6 h-6" />
                                <span className="text-xs">{chat.filename}</span>
                            </div>
                        }
                        <div className="w-full h-1 bg-gray-300 rounded-full overflow-hidden mt-1">
                            <div className="h-1 bg-green-500" style={{ width: `${chat.progress}%` }}></div>
                        </div>
                    </div>
                )}

                {chat.type === "file" && (
                    isImage() ? (
                        <img src={chat.message} alt={chat.filename}
                            className="max-w-[200px] rounded" />
                    ) : (
                        <a href={chat.message} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-sm underline">
                            <img src={getFileIcon()} alt="file" className="w-6 h-6" />
                            {chat.filename}
                        </a>
                    )
                )}

                {chat.type === "text" && <p className="text-sm">{chat.message}</p>}

                <p className={`text-[10px] mt-1 ${isMine ? "text-gray-600" : "text-gray-400"}`}>
                    {moment(chat.time).format("hh:mm A")}
                </p>

                {
                    isLastInGroup && <div className={`absolute w-0 h-0 border-l-[8px] border-r-[8px] border-t-[8px] ${isMine ? "border-l-transparent border-r-transparent border-t-gray-300 right-3" : "border-l-transparent border-r-transparent border-t-white left-3"}`} style={{ bottom: "-8px" }} />
                }
            </div>
        </div>
    )
}
